<script>
  export default {
    props: {
      platforms: {
        type: Array,
        required: true,
      },
    },
    methods: {
      togglePlatform(platformName, checked) {
        this.$emit("update-platform", { name: platformName, checked });
      },
    },
  };
</script>

<template>
  <ul class="platformCheckbox">
    <li class="userPlatforms__checkbox" v-for="platform in platforms" :key="platform.name">
      <input
        class="mycheck"
        type="checkbox"
        :id="platform.name"
        :value="platform.name"
        :checked="platform.isSelected"
        :style="{ '--platform-color': platform.color }"
        @change="togglePlatform(platform.name, $event.target.checked)"
      />
      <label :for="platform.name" :style="{ color: platform.color }">{{ platform.name }}</label>
    </li>
  </ul>
</template>

<style lang="scss">
  .platformCheckbox {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    width: 100%;
    gap: 7.5px;
    padding: 14px 0px;
    border-bottom: solid 1px #c4c4c4;
  }

  .userPlatforms__checkbox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: 7.5px;
  }

  .mycheck {
    gap: 7.5px;
    width: 20px;
    height: 20px;
    padding: 5px;
    border-radius: 4px;
    &:checked {
      background-color: var(--platform-color, $primary-color);
      border-color: var(--platform-color, $primary-color);
    }
    border: solid 1px #c4c4c4;
  }
</style>
